module.exports = __webpack_public_path__ + "img/photo-0081.2a013763.jpg";